import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Logout from './Logout'

import { actionCreators } from '@/checkout-instore-legacy/vendor/actions'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(null, mapDispatchToProps)(Logout)
